import { Menubar } from '@tecsinapse/cortex-react'
import React from 'react'
import { LeftComponent, RightComponent } from '../components'
import { useHeaderNav } from '../hooks'
import { headerNavVariants } from '../styles'

const { container } = headerNavVariants()

const HeaderNav = () => {
  const { userMenu, filteredMenuOptions, handleSearch } = useHeaderNav()

  return (
    <div className={container()}>
      <Menubar.Root>
        <Menubar.Header>
          <Menubar.HeaderLeft>
            <LeftComponent />
          </Menubar.HeaderLeft>
          <Menubar.Search
            bounceTimeout={250}
            onChange={value => handleSearch(value)}
            placeholder={'O que você deseja buscar?'}
          />
          <Menubar.HeaderRight>{userMenu && <RightComponent userMenu={userMenu} />}</Menubar.HeaderRight>
        </Menubar.Header>
        <Menubar.DropdownRoot options={filteredMenuOptions} />
      </Menubar.Root>
    </div>
  )
}

export default HeaderNav
